/**
 * 다발 발사 시 각도 offset 배수를 반환한다 (step 단위, 발사 순서대로).
 * 항상 정중앙(0)을 첫 원소로 포함 → 짝수 발에서도 타겟 정조준 총알 보장
 * (중앙 누락 시 단일 벽돌을 영원히 빗나가 게임이 멈추는 현상 방지).
 * 이후 오른쪽(+) → 왼쪽(-) 교대로 바깥 확장.
 *   1→[0]  2→[0,1]  3→[0,1,-1]  4→[0,1,-1,2]  5→[0,1,-1,2,-2]
 *
 * 모든 총알은 같은 프레임에 동시 spawn되므로 비중앙 총알의 좌/우 순서는
 * 게임플레이에 영향 없음(시각 배열만). 핵심 불변식은 offsets[0] === 0.
 */
export function spreadAngleOffsets(n: number): number[] {
  // 비유한(Infinity/NaN) 입력은 무한 루프를 막기 위해 1발로 보정 (public API 방어).
  const count = Number.isFinite(n) ? Math.max(1, Math.floor(n)) : 1;
  const offsets: number[] = [0];
  let k = 1;
  while (offsets.length < count) {
    offsets.push(k);
    if (offsets.length < count) offsets.push(-k);
    k++;
  }
  return offsets;
}
